// extracted by mini-css-extract-plugin
export default {"bottomModal":"MyBottomSheet_bottomModal__VA9U2","hidden":"MyBottomSheet_hidden__8YjsT","header":"MyBottomSheet_header__0ffyq","content":"MyBottomSheet_content__vLxyG"};